import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular'

@Injectable()
export class LocationService {

    constructor(private restangular:Restangular) {
    }

    getAllLocations() {
        return this.restangular.all('getAllLocations');
    }

    getLocationsFormData() {
        return this.restangular.one('getAllEmployeesFormData');
    }

    locationCRUD() {
        return this.restangular.all('locationsCRUD');
    }

    getLocationsByCountry() {
        return this.restangular.one('getLocationsByCountry');
    }

    getLocationsByRegion() {
        return this.restangular.one('getLocationsByRegion');
    }

    getSelectedCountryLocationsMulti() {
      return this.restangular.all('getSelectedCountryLocationsMulti');
    }

    getAllRegions(){
        return this.restangular.all('getAllRegions');
    }

    public regionCRUD() {
      return this.restangular.all("regions");
    }

    public regionUD(id = 0) {
      let url = "regions";
      if (id > 0) {
        url = url + "/" + id;
      }
      return this.restangular.one(url);
    }

  getSelectedRegionLocationsMulti() {
    return this.restangular.all('getSelectedRegionLocationsMulti');
  }

  getDivisionBaseDepartment() {
    return this.restangular.all('getDivisionBaseDepartment');
  }

  getSegmentBaseSecondaryCompany() {
    return this.restangular.all('getSegmentBaseSecondaryCompany');
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/location.service.ts